var exports = {
  "DD": "x936d19a0--958ab2--title",
  "$z": "x936d19a0--958ab2--title-sale-rent",
  "h_": "x936d19a0--958ab2--description",
  "_8": "x936d19a0--958ab2--img",
  "qE": "x936d19a0--958ab2--img-sale-rent",
};

module.exports = exports;
